export * from './version.service';
import { VersionService } from './version.service';
export const APIS = [VersionService];
